import { useState } from 'react';
import { getValueOnLocalStorage, setValueOnLocalStorage } from '../utils/localStorage';

const KEY = 'diceAnimEnabled';

export function useDiceAnimSetting() {
  const [enabled, setEnabled] = useState(() => {
    const stored = getValueOnLocalStorage(KEY);
    return stored === null ? true : stored;
  });

  const toggle = () => {
    setEnabled(prev => {
      setValueOnLocalStorage(KEY, !prev);
      return !prev;
    });
  };

  return [enabled, toggle];
}
